(() => {
  const actionSelector = '[role="button"],[role="tab"],[download],[data-no-new-tab],.m-cart-icon-bubble';
  function updateLink(link) {
    const href = (link.getAttribute('href') || '').trim();
    if (!href || href.startsWith('#') || link.matches(actionSelector)) return;
    let url;
    try { url = new URL(href, document.baseURI); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol)) return;
    const current = new URL(location.href);
    const local = url.origin === current.origin;
    if (local && url.pathname === current.pathname && url.search === current.search && url.hash) return;
    if (local && /^\/(?:cart\/(?:add|change|update|clear)|checkout|checkouts|account\/logout)(?:\/|$|\.)/.test(url.pathname)) return;
    if (link.target !== '_blank') link.target = '_blank';
    link.relList.add('noopener');
  }
  function updateTree(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('a[href]')) updateLink(root);
    root.querySelectorAll('a[href]').forEach(updateLink);
  }
  function start() {
    updateTree(document);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') updateLink(record.target);
        else record.addedNodes.forEach(updateTree);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'target'] });
    document.addEventListener('click', event => {
      const link = event.target.closest && event.target.closest('a[href]');
      if (link) updateLink(link);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();